import {
  LOG_IN,
  LOG_IN_SUCCESS,
  LOG_IN_FAIL,
  LOG_OUT,
  RESET_PASSWORD_CLEAR,
  GET_USER_INFO_SUCCESS,
} from './types';

const initialState = {
  accessToken: null,
  permissions: '',
  isAuthenticated: false,
  loginErr: null,
  loader: false,
  admin: null,
  isAuthorized: null,
  user: null,
  getLinkLoading: false,
  getLinkSuccess: null,
  resetSuccess: false,
  closeResetSuccess: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case LOG_IN:
    return {
      ...state,
      loader: true,
    };

  case LOG_OUT:
    return {
      ...state,
      admin: null,
      accessToken: null,
      permissions: '',
      isAuthorized: null,
      isAuthenticated: false,
      loader: false,
    };

  case LOG_IN_SUCCESS:
    return {
      ...state,
      admin: null,
      accessToken: action.payload.access_token,
      permissions: null,
      loader: false,
    };

  case GET_USER_INFO_SUCCESS:
    return {
      ...state,
      user: action.payload,
    };

  case LOG_IN_FAIL:
    return {
      ...state,
      loginErr: action.payload,
      loader: false,
    };

  case RESET_PASSWORD_CLEAR:
    return {
      ...state,
      resetSuccess: false,
      closeResetSuccess: 'close',
    };
  default:
    return state;
  }
};
